const GENERAL_REGION = 'ap-south-1'
const KB_REGION = 'us-east-1'

const DEV_HOSTNAMES = new Set([
  'localhost',
  '127.0.0.1',
  'dev.portal.yandle.io',
  'www.dev.portal.yandle.io',
])

const ENVIRONMENTS = {
  dev: {
    key: 'dev',
    userPoolId: 'ap-south-1_0Mb5fNntR',
    userPoolClientId: '7vr4eiho679tc8q08e23s5o6as',
    identityPoolId: 'ap-south-1:369478c0-d7a8-4a69-92f0-766f69007ae3',
    graphqlEndpoint:
      'https://bvs6fi2lbfee3hw6zx67wyboim.appsync-api.ap-south-1.amazonaws.com/graphql',
    region: GENERAL_REGION,
    s3Bucket: 'yandle-dev',
    s3Region: GENERAL_REGION,
    kbS3Bucket: 'yandle-kb-dev',
    kbS3Region: KB_REGION,
    // The x-api-key the public API actually requires (an API Gateway usage-plan
    // key). One per environment, NOT per organisation -- which is why it never
    // belonged on the org record. It is safe here for the same reason
    // userPoolId and identityPoolId are: on its own it authenticates nothing,
    // the request is still rejected 401 without a valid OAuth token.
    publicApiKey: 'WjtuVSFgCd3VJFMo5OiLR395YZyuJ2607AgnuhjL',
  },
  prod: {
    key: 'prod',
    userPoolId: 'ap-south-1_n6FBwL8I4',
    userPoolClientId: '4dtllrs09g49i8bf9hg3n4ol9s',
    identityPoolId: 'ap-south-1:fe6753d2-1c1d-48fe-9ef1-1a23314c1565',
    graphqlEndpoint:
      'https://nadrxcnltzegdkjycgh7utloou.appsync-api.ap-south-1.amazonaws.com/graphql',
    region: GENERAL_REGION,
    s3Bucket: 'yandle-prod',
    s3Region: GENERAL_REGION,
    kbS3Bucket: 'yandle-kb-prod',
    kbS3Region: KB_REGION,
    publicApiKey: 'j00v3pEXkf5heo9zgKth9b39ODO0xwC5w3ycjIvc',
  },
}

export const S3_STORAGE_SCOPE = {
  GENERAL: 'general',
  KNOWLEDGE_BASE: 'knowledge-base',
}

export function isDevPortalHostname(hostname) {
  const host = String(hostname ?? '').trim().toLowerCase()
  if (!host) return true
  if (DEV_HOSTNAMES.has(host)) return true
  return host.endsWith('.localhost')
}

// Real deployments (dev.portal.yandle.io / the prod domain) are always
// resolved by hostname above, on purpose -- this override only matters on
// localhost, where the hostname alone can't say which backend you want.
// Set VUE_APP_PORTAL_ENV=prod|dev in .env.local (gitignored, personal to
// your machine) to flip it, then restart `npm run serve`.
function getLocalPortalEnvOverride() {
  const value = String(process.env.VUE_APP_PORTAL_ENV ?? '').trim().toLowerCase()
  return value === 'dev' || value === 'prod' ? value : null
}

export function resolvePortalEnvironmentKey(hostname) {
  const override = getLocalPortalEnvOverride()
  if (override) return override
  return isDevPortalHostname(hostname) ? 'dev' : 'prod'
}

export function getPortalEnvironment(hostname) {
  const key = resolvePortalEnvironmentKey(
    typeof hostname === 'string'
      ? hostname
      : typeof window !== 'undefined'
        ? window.location.hostname
        : '',
  )
  return ENVIRONMENTS[key]
}

export function resolveS3StorageTarget(scope = S3_STORAGE_SCOPE.GENERAL, hostname) {
  const env = getPortalEnvironment(hostname)

  if (scope === S3_STORAGE_SCOPE.KNOWLEDGE_BASE) {
    return {
      bucket: env.kbS3Bucket,
      region: env.kbS3Region,
    }
  }

  return {
    bucket: env.s3Bucket,
    region: env.s3Region,
  }
}

export function getAmplifyConfig(hostname) {
  const env = getPortalEnvironment(hostname)

  return {
    Auth: {
      Cognito: {
        userPoolId: env.userPoolId,
        userPoolClientId: env.userPoolClientId,
        identityPoolId: env.identityPoolId,
        allowGuestAccess: true,
        region: env.region,
        loginWith: {
          email: true,
        },
      },
    },
    API: {
      GraphQL: {
        endpoint: env.graphqlEndpoint,
        region: env.region,
        defaultAuthMode: 'userPool',
      },
    },
    Storage: {
      S3: {
        bucket: env.s3Bucket,
        region: env.s3Region,
      },
    },
  }
}
